import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { NavService } from '../../_services/_nav.service';
import { NivelesService } from '../../_services/niveles.service';
import { UsuariosService } from '../../_services/usuarios.service';
import { Table } from 'primeng/table';
import { NivelDescuentoService } from '../../_services/nivel-descuento.service';
import { NivelDescuento } from '../../_models/nivel-descuento';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Nivel } from '../../_models/nivel';
import { ConfirmationService } from 'primeng/api';

@Component( {
  selector: 'app-nivel-descuento-tasa',
  templateUrl: 'niveles-descuento-tasa.component.html'
} )

export class NivelesDescuentoTasaComponent implements OnInit {

  @Input()
  nivel: Nivel;
  columnas: any[] = [];
  @ViewChild('dt') t: Table;

  //
  nivelDescuento: NivelDescuento[] = [];
  formulario: FormGroup;
  submitted = false;
  guardando = false;
  cargandoTabla = false;
  nombreValido = true;
  puntosValido = true;

  constructor(
    private route: ActivatedRoute,
    private nivelesServicio: NivelesService,
    private nivelDescuentoService: NivelDescuentoService,
    private usuarioService: UsuariosService,
    private navService: NavService,
    private location: Location,
    private confirmationService: ConfirmationService,
    private fb: FormBuilder
  ) {
  }

  ngOnInit(): void {

    this.columnas = [
      { field: 'nombre', header: this.navService.buscarMensaje( 'LBL_NOMBRE' ), sort: true },
      { field: 'puntosDescuento', header: this.navService.buscarMensaje( 'NIVELES.LBL_NIVELDESCUENTO' ), sort: true },
      { field: 'indicadorHabilitado', header: this.navService.buscarMensaje( 'LBL_HABILITADO' ), sort: false },
      { field: 'det', header: this.navService.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];
    if ( this.nivel ) {
      this.refrescar();
    }

  }

  get f() {
    return this.formulario.controls;
  }

  cargarFormulario( nivelDescuento?: NivelDescuento ) {
    this.submitted = false;
    this.puntosValido = true;
    this.nombreValido = true;
    this.formulario = this.fb.group( {
      idNivelDescuento: [ nivelDescuento ? nivelDescuento.idNivelDescuento : null, [] ],
      idNivel: [ this.nivel.idNivel, [ Validators.required ] ],
      nombre: [ nivelDescuento ? nivelDescuento.nombre : null, [ Validators.required, Validators.maxLength(50) ] ],
      puntosDescuento: [ nivelDescuento ? nivelDescuento.puntosDescuento : null, [ Validators.required ] ],
      indicadorHabilitado: [ !nivelDescuento || nivelDescuento.indicadorHabilitado, [ Validators.required ] ]
    } );
  }

  validarUnicoNombre( value ) {
    value = value ? value.toLowerCase() : '';
    this.nombreValido = this.nivelDescuento.find( x => x.nombre.toLowerCase() === value ) === undefined;
  }

  validarUnicaTasa( value ) {
    this.puntosValido = this.nivelDescuento.find( x => x.puntosDescuento === Number( value ) ) === undefined;
  }

  guardar() {
    this.submitted = true;
    if ( this.formulario.invalid || !this.nombreValido || !this.puntosValido ) {
      return;
    }
    if ( this.f.idNivelDescuento.value ) {
      this.nivelDescuentoService.actualizar( this.formulario.value )
        .subscribe( () => {
          this.refrescar();
          this.navService.setMesage( 2,
            {
              severity: 'info',
              summary: this.navService.buscarMensaje( 'LBL_INFORMACION' ),
              detail: this.navService.buscarMensaje( 'NIVELES.LBL_REGGUAR' )
            } );
        } );
    } else {
      this.nivelDescuentoService.agregar( this.formulario.value )
        .subscribe( () => {
          this.navService.setMesage( 1,
            {
              severity: 'info',
              summary: this.navService.buscarMensaje( 'LBL_INFORMACION' ),
              detail: this.navService.buscarMensaje( 'NIVELES.LBL_REGGUAR' )
            } );
          this.refrescar();
        } );
    }
  }

  editar( row: NivelDescuento ) {
    this.cargarFormulario( row );
  }

  limpiar() {
    if ( this.formulario.dirty ) {
      this.confirmationService.confirm( {
        message: this.navService.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navService.buscarMensaje( 'LBL_CONFIRMACION' ),
        key: 'niveles-descuentos',
        icon: 'fa fa-question-circle',
        accept: () => {
          this.cargarFormulario( null );
        },
        reject: () => {
        }
      } );
    } else {
      this.cargarFormulario( null );
    }
  }

  refrescar() {
    // bool para spinner de cargar pantalla
    this.cargandoTabla = true;

    // Llamar a refrescar datatable
    this.cargarFormulario( null );
    this.nivelDescuentoService.obtenerPorIdNivel( this.nivel.idNivel )
      .subscribe( res => {
        this.nivelDescuento = res;
        this.cargandoTabla = false;
      } );
  }

  atras() {
    this.location.back();
  }

}
